import { Link, useParams } from 'react-router-dom'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { DetailHeader } from '@/components/common/DetailHeader'
import { useConfigurations } from './hooks'
import { GeneralPanel } from './components/GeneralPanel'
import { SectionsPanel } from './components/SectionsPanel'
import { CompositionPanel } from './components/CompositionPanel'
import { TracksPanel } from './components/TracksPanel'
import { StagesPanel } from '@/features/admin/stages/components/StagesPanel'
import { DocumentTypesPanel } from '@/features/admin/document-types/DocumentTypesPanel'
import { AnnexRequirementsPanel } from './components/AnnexRequirementsPanel'
import { CashScheduleTemplateEditor } from '@/features/contract/financing/components/CashScheduleTemplateEditor'
import { SourceMappingPanel } from './components/SourceMappingPanel'

export function ConfigurationDetailPage() {
  const { code: configurationCode } = useParams<{ code: string }>()
  const products = useConfigurations(false)
  const product = products.data?.find(p => p.code === configurationCode)

  if (products.isLoading) return <div className="p-4">Ładowanie...</div>
  if (!product) {
    return (
      <div className="p-4">
        <p className="text-sm text-red-600">Konfiguracja nie znaleziona.</p>
        <Link to="/settings/configurations" className="text-sm text-sky-700 underline">← wróć do listy konfiguracji</Link>
      </div>
    )
  }

  return (
    <div className="flex flex-col w-full h-full">
      <DetailHeader
        title={product.labelPl}
        subtitle={
          <span className="font-mono">
            {product.code} · {product.isActive ? 'aktywny' : 'nieaktywny'}
          </span>
        }
      />

      <Tabs defaultValue="general" className="flex-1 flex flex-col gap-0 overflow-hidden">
        <TabsList className="rounded-none w-full justify-start gap-2 px-4 border-b bg-white h-auto">
          <TabsTrigger value="general">Ogólne</TabsTrigger>
          <TabsTrigger value="products">Produkty (elementy)</TabsTrigger>
          <TabsTrigger value="sections">Sekcje formularza</TabsTrigger>
          <TabsTrigger value="tracks">Tory statusów</TabsTrigger>
          <TabsTrigger value="stages">Etapy</TabsTrigger>
          <TabsTrigger value="schedule">Harmonogram</TabsTrigger>
          <TabsTrigger value="document-types">Typy dokumentów</TabsTrigger>
          <TabsTrigger value="annex">Aneks</TabsTrigger>
          <TabsTrigger value="field-mappings">Mapowanie pól</TabsTrigger>
        </TabsList>

        <TabsContent value="general" className="flex-1 overflow-auto p-4">
          <GeneralPanel product={product} />
        </TabsContent>
        <TabsContent value="products" className="flex-1 overflow-auto p-4">
          <CompositionPanel configurationCode={product.code} />
        </TabsContent>
        <TabsContent value="sections" className="flex-1 overflow-auto p-4">
          <SectionsPanel configurationCode={product.code} />
        </TabsContent>
        <TabsContent value="tracks" className="flex-1 overflow-auto p-4">
          <TracksPanel configurationCode={product.code} />
        </TabsContent>
        <TabsContent value="stages" className="flex-1 overflow-auto p-4">
          <StagesPanel owner={product.code} />
        </TabsContent>
        <TabsContent value="schedule" className="flex-1 overflow-auto p-4">
          <CashScheduleTemplateEditor scope="configurations" code={product.code} />
        </TabsContent>
        <TabsContent value="document-types" className="flex-1 overflow-auto p-4">
          <DocumentTypesPanel configurationCode={product.code} />
        </TabsContent>
        <TabsContent value="annex" className="flex-1 overflow-auto p-4">
          <AnnexRequirementsPanel configurationCode={product.code} />
        </TabsContent>
        <TabsContent value="field-mappings" className="flex-1 overflow-auto p-4">
          <SourceMappingPanel configurationCode={product.code} />
        </TabsContent>
      </Tabs>
    </div>
  )
}
